import { Typography } from "@mui/material"
import { useState } from "react"
import { removeInstitution } from "../../api"
import Modal from "../ui/Modal"
import { useSnackbar } from "notistack"

const DeleteInstitution = (props) => {
    const { enqueueSnackbar } = useSnackbar()
    const [loading, setLoading] = useState(false)
    const DeleteInstitution = () => {
        setLoading(true)
        removeInstitution(props.data?.id)
            .then(() => {
                enqueueSnackbar("Institution Deleted", { variant: "success" })
                props.refresh()
                props.close()
            })
            .catch((err) => enqueueSnackbar(err.data, { variant: "error" }))
            .finally(() => setLoading(false))
    }
    return (
        <Modal
            {...props}
            title="Delete Institution"
            actionText="Delete"
            loading={loading}
            action={DeleteInstitution}
        >
            <Typography>
                Do you want to delete institution '{props.data?.name}'? <br /> All material
                will be deleted.
            </Typography>
        </Modal>
    )
}

export default DeleteInstitution